export const SECTIONS_NAMES = {
  useCases: 'useCases',
  features: 'features',
  contacts: 'contacts'
};
